import { gql } from '@apollo/client'

export const PREPARE_PAYMENT_MUTATION = gql`
  mutation PreparePayment($input: PreparePaymentInput!) {
    preparePayment(input: $input) {
      paymentNumber
    }
  }
`
